import { Component } from '@angular/core';
import { ModalDoubleFactorComponent } from '../../modal-double-factor/modal-double-factor.component';
import Rutas from 'src/app/Models/Base/rutas';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from '../../modal/modal.component';

@Component({
  selector: 'app-modal-invalid-phone',
  templateUrl: './modal-invalid-phone.component.html',
  styleUrls: ['./modal-invalid-phone.component.scss'],
  standalone: true,
  imports: [
    ModalComponent
  ]
})
export class ModalInvalidPhoneComponent {
  constructor(
    private dialogRef: MatDialogRef<ModalDoubleFactorComponent>,
    public appStateService: AppStateService
  ) {}

  MisDatos(): void {
    this.appStateService.router.navigateByUrl(Rutas.MY_ACCOUNT);
    this.onClose();
  }

  CerrarModal() {
    this.onClose();
  }

  onClose = (data?: { [key: string]: any }) =>
    this.dialogRef.close({ ...data });
}
